import React, {useState} from 'react'
import './services.css'

const Services = () => {
    const [toggleState, setToggleState] = useState(0);
    const toggleTab = (index) => {
        setToggleState(index);
    }
    return (
        <section className="services section" id="services">
            <h2 className="section__title">Servicios</h2>
            <span className='section__subtitle'>-</span>

            <div className="services__container container grid" >
                <div className="services__content">
                    <div>
                        <i className='uil uil-server-alt services__icon'></i>
                        <h3 className='services__title'>
                            Desarrollo <br /> web
                        </h3>
                    </div>
                    <span className='services__button' onClick={() => toggleTab(1)}>
                        Detalle
                        <i className='uil uil-arrow-right services__button-icon'></i>
                    </span>

                    <div className={toggleState === 1 
                        ? 'services__modal active-modal'
                        : 'services__modal'}>
                        <div className='services__modal-content'>
                            <i onClick={() => toggleTab(0)}
                                className='uil uil-times services__modal-close'></i>
                            <h3 className='services__modal-title'>Desarrollo web</h3>
                            {/* <p className='services__modal-description'>
                                Desarrollo web
                            </p> */}

                            <ul className='services__modal-services grid'>
                                <li className='services__modal-service'>
                                    <i className='uil uil-check-circle service__modal-icon'></i>
                                    <p className='services__modal-info'>
                                    Análisis y levantamiento de requerimientos.
                                    </p>
                                </li>

                                <li className='services__modal-service'>
                                    <i className='uil uil-check-circle service__modal-icon'></i>
                                    <p className='services__modal-info'>
                                        Planificación y arquitectura.
                                    </p>
                                </li>

                                <li className='services__modal-service'>
                                    <i className='uil uil-check-circle service__modal-icon'></i>
                                    <p className='services__modal-info'>
                                        Diseño UX/UI.
                                    </p>
                                </li>

                                <li className='services__modal-service'>
                                    <i className='uil uil-check-circle service__modal-icon'></i>
                                    <p className='services__modal-info'>
                                        Desarrollo.
                                    </p>
                                </li>

                                <li className='services__modal-service'>
                                    <i className='uil uil-check-circle service__modal-icon'></i>
                                    <p className='services__modal-info'>
                                        Despliegue y publicación.
                                    </p>
                                </li>

                                <li className='services__modal-service'>
                                    <i className='uil uil-check-circle service__modal-icon'></i>
                                    <p className='services__modal-info'>
                                        Pruebas y control de calidad.
                                    </p>
                                </li>
                                <li className='services__modal-service'>
                                    <i className='uil uil-check-circle service__modal-icon'></i>
                                    <p className='services__modal-info'>
                                        Soporte y mejora continua.
                                    </p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div className="services__content">
                    <div>
                        <i className='uil uil-server-alt services__icon'></i>
                        <h3 className='services__title'>
                            Desarrollo <br /> mobile
                        </h3>
                    </div>
                    <span className='services__button' onClick={() => toggleTab(2)}>
                        Detalle
                        <i className='uil uil-arrow-right services__button-icon'></i>
                    </span>

                    <div className={toggleState === 2 
                        ? 'services__modal active-modal'
                        : 'services__modal'}>
                        <div className='services__modal-content'>
                            <i onClick={() => toggleTab(0)}
                                className='uil uil-times services__modal-close'></i>
                            <h3 className='services__modal-title'>Desarrollo mobile</h3>
                            {/* <p className='services__modal-description'>
                                Cloud is a service description
                            </p> */}

                            <ul className='services__modal-services grid'>
                                <li className='services__modal-service'>
                                    <i className='uil uil-check-circle service__modal-icon'></i>
                                    <p className='services__modal-info'>
                                        Análisis de la idea y objetivos.
                                    </p>
                                </li>

                                <li className='services__modal-service'>
                                    <i className='uil uil-check-circle service__modal-icon'></i>
                                    <p className='services__modal-info'>
                                        Planificación técnica.
                                    </p>
                                </li>

                                <li className='services__modal-service'>
                                    <i className='uil uil-check-circle service__modal-icon'></i>
                                    <p className='services__modal-info'>
                                        Diseño UX/UI Mobile.
                                    </p>
                                </li>

                                <li className='services__modal-service'>
                                    <i className='uil uil-check-circle service__modal-icon'></i>
                                    <p className='services__modal-info'>
                                        Desarrollo de la aplicación.
                                    </p>
                                </li>

                                <li className='services__modal-service'>
                                    <i className='uil uil-check-circle service__modal-icon'></i>
                                    <p className='services__modal-info'>
                                        Pruebas y validación.
                                    </p>
                                </li>

                                <li className='services__modal-service'>
                                    <i className='uil uil-check-circle service__modal-icon'></i>
                                    <p className='services__modal-info'>
                                        Publicación en tiendas.
                                    </p>
                                </li>

                                <li className='services__modal-service'>
                                    <i className='uil uil-check-circle service__modal-icon'></i>
                                    <p className='services__modal-info'>
                                        Soporte y evolución.
                                    </p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div className="services__content">
                    <div>
                        <i className='uil uil-server-alt services__icon'></i>
                        <h3 className='services__title'>
                            Integración <br /> de sistemas web
                        </h3>
                    </div>
                    <span className='services__button' onClick={() => toggleTab(3)}>
                        Detalle
                        <i className='uil uil-arrow-right services__button-icon'></i>
                    </span>

                    <div className={toggleState === 3 
                        ? 'services__modal active-modal'
                        : 'services__modal'}>
                        <div className='services__modal-content'>
                            <i onClick={() => toggleTab(0)}
                                className='uil uil-times services__modal-close'></i>
                            <h3 className='services__modal-title'>Integración de sistemas web</h3>
                            {/* <p className='services__modal-description'>
                                Integración de sistemas web description
                            </p> */}

                            <ul className='services__modal-services grid'>
                                <li className='services__modal-service'>
                                    <i className='uil uil-check-circle service__modal-icon'></i>
                                    <p className='services__modal-info'>
                                        Análisis de sistemas existentes.
                                    </p>
                                </li>

                                <li className='services__modal-service'>
                                    <i className='uil uil-check-circle service__modal-icon'></i>
                                    <p className='services__modal-info'>
                                        Definición de la estrategia de integración.
                                    </p>
                                </li>

                                <li className='services__modal-service'>
                                    <i className='uil uil-check-circle service__modal-icon'></i>
                                    <p className='services__modal-info'>
                                        Diseño de arquitectura de integración.
                                    </p>
                                </li>

                                <li className='services__modal-service'>
                                    <i className='uil uil-check-circle service__modal-icon'></i>
                                    <p className='services__modal-info'>
                                        Desarrollo de conectores e interfaces.
                                    </p>
                                </li>

                                <li className='services__modal-service'>
                                    <i className='uil uil-check-circle service__modal-icon'></i>
                                    <p className='services__modal-info'>
                                        Pruebas de integración.
                                    </p>
                                </li>

                                <li className='services__modal-service'>
                                    <i className='uil uil-check-circle service__modal-icon'></i>
                                    <p className='services__modal-info'>
                                        Implementación en producción.
                                    </p>
                                </li>

                                <li className='services__modal-service'>
                                    <i className='uil uil-check-circle service__modal-icon'></i>
                                    <p className='services__modal-info'>
                                        Soporte y optimización.
                                    </p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Services
